<template>
	<div id="iteminfo">
		<el-table
			v-loading="loading"
			:data="tableData"
			border
			height="78vh"
			>
			<el-table-column
				prop="id"
				label="ID"
				width="240">
			</el-table-column>
			<el-table-column
				fixed
				prop="date"
				label="日期"
				width="240">
			</el-table-column>
			<el-table-column
				prop="about"
				label="分类"
				width="240">
			</el-table-column>
			<el-table-column
				prop="title"
				label="标题"
				width="420">
			</el-table-column>
			<el-table-column
				fixed="right"
				label="操作"
				width="200">
				<template slot-scope="scope">
					<el-button @click="dele(scope.row.id,scope.$index)" type="text" size="small">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	
	export default {
		name:'iteminfo',
		props:{
			tableData:{
				type:Array,
				default(){
					return []
				}
			},
			loading:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				
			}
		},
		methods:{
			dele(id,index) {
					this.$emit('dele',id,index)
			}
		}
	}
</script>

<style scoped>
	#iteminfo{

	}
</style>